import type { AnswerValue } from './answers/types'

const STORAGE_PREFIX = 'expat-passport.survey.'

type Draft = Record<string, AnswerValue>

function keyOf(survey: string): string {
  return STORAGE_PREFIX + survey
}

function read(survey: string): Draft {
  try {
    const saved = window.localStorage.getItem(keyOf(survey))

    return saved ? (JSON.parse(saved) as Draft) : {}
  } catch {
    return {}
  }
}

function write(survey: string, draft: Draft): void {
  try {
    window.localStorage.setItem(keyOf(survey), JSON.stringify(draft))
  } catch {
    // Storage a browser refuses is not a reason to lose the current answer.
  }
}

// loadAnswer returns what was typed but never sent. A question is answered on
// the server the moment the button is pressed, so this only ever holds the one
// the person is looking at — and losing it to a reload is the one thing that
// makes somebody abandon a questionnaire halfway.
export function loadAnswer(survey: string, question: string): AnswerValue | undefined {
  return read(survey)[question]
}

export function saveAnswer(survey: string, question: string, value: AnswerValue | undefined): void {
  const draft = read(survey)

  if (value === undefined) {
    delete draft[question]
  } else {
    draft[question] = value
  }

  write(survey, draft)
}

export function forgetAnswers(survey: string): void {
  try {
    window.localStorage.removeItem(keyOf(survey))
  } catch {
    // Nothing to do: the draft outliving the run is harmless, it is keyed by
    // question and the next run asks different ones.
  }
}
